import React from "react";
import { SvgIcon } from "@mui/material";
import { SvgIconsProps } from "~/common";

export const Shield = (props: SvgIconsProps) => {
  return (
    <SvgIcon {...props}>
      <path
        d="M13.724 19.6093C13.984 19.8693 14.3253 19.9999 14.6667 19.9999C15.008 19.9999 15.3493 19.8693 15.6093 19.6093L20.9427 14.2759C21.464 13.7546 21.464 12.9119 20.9427 12.3906C20.4213 11.8693 19.5787 11.8693 19.0573 12.3906L14.6667 16.7813L12.9427 15.0573C12.4213 14.5359 11.5787 14.5359 11.0573 15.0573C10.536 15.5786 10.536 16.4213 11.0573 16.9426L13.724 19.6093Z"
        fill="#008769"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.404 30.5266C15.5907 30.6199 15.796 30.6666 16 30.6666C16.204 30.6666 16.4093 30.6199 16.596 30.5266C17.0613 30.2933 28 24.7239 28 15.9999V6.66661C28 6.11061 27.6547 5.61328 27.1347 5.41728L16.468 1.41728C16.1667 1.30394 15.8347 1.30394 15.532 1.41728L4.86533 5.41728C4.34533 5.61328 4 6.11061 4 6.66661V15.9999C4 24.7239 14.9387 30.2933 15.404 30.5266ZM6.66667 15.9999V7.59061L16 4.09061L25.3333 7.59061V15.9999C25.3333 22.0479 18.1427 26.5946 15.9987 27.8159C13.8533 26.5973 6.66667 22.0653 6.66667 15.9999Z"
        fill="#008769"
      />
    </SvgIcon>
  );
};
